import React from 'react';

/** Placeholder — e-invoice UI is optional until GSP is configured for LSV. */
function InvoiceEinvoiceSection({ config }) {
    if (!config || config.enabled) {
        return null;
    }
    return null;
}

export default InvoiceEinvoiceSection;
